import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-bidding-details',
    templateUrl: './bidding-details.component.html',
    standalone: false
})
export class BiddingDetailsComponent {

    @Input() auction: any;


    public FormatDate(stringDate) {         
        var options = { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', timeZoneName: 'short' };
        //return new Date(stringDate).toLocaleDateString('en-US', options);
        return new Date(stringDate);
    }

}
